/** Sentinel sent as the user message content when a voice question is skipped. */
export const SKIP_RESPONSE_VALUE = "Skip";

/**
 * Friendly text shown in the candidate transcript in place of the raw S3 key
 * sent as the message payload for voice answers. Used both for the optimistic
 * in-memory message and for resumed transcripts where the persisted content
 * is the `s3://…` key.
 */
export const VOICE_RESPONSE_DISPLAY_TEXT = "Voice response submitted";

/** Prefix that identifies a voice-transport message payload (S3 key). */
export const VOICE_S3_KEY_PREFIX = "s3://";
